import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { themeColors } from '../theme'

interface DisclaimerProps {
  val: string | React.ReactNode
  firstMessage: boolean
}

const Disclaimer: React.FC<DisclaimerProps> = ({ val, firstMessage }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded((prev) => !prev)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggleExpand()
    }
  }

  return (
    <div style={{ textAlign: 'center', background: themeColors.background }}>
      <div
        tabIndex={0}
        role="button"
        style={{
          padding: '0.5rem 1rem',
          fontSize: '14px',
          color: themeColors.standardText,
          borderTop: `1px solid ${themeColors.border}`,
          borderLeft: `1px solid ${themeColors.border}`,
          borderRight: `1px solid ${themeColors.border}`,
          backgroundColor: themeColors.background,
          lineHeight: '1.4em',
          cursor: 'pointer',
          maxHeight: expanded ? 'none' : '1.8em',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 'unset' : 2,
          WebkitBoxOrient: 'vertical',
        }}
        onClick={toggleExpand}
        aria-expanded={expanded}
        aria-label={
          expanded ? 'Collapse privacy policy' : 'Expand privacy policy'
        }
      >
        {firstMessage && !expanded ? 'Click here to see privacy policy' : val}
      </div>

      <div
        style={{
          paddingTop: '4px',
          cursor: 'pointer',
          background: themeColors.background,
          borderTop: `1px solid ${themeColors.border}`,
          borderLeft: `1px solid ${themeColors.border}`,
          borderRight: `1px solid ${themeColors.border}`,
        }}
        tabIndex={0}
        onClick={toggleExpand}
        onKeyDown={handleKeyDown}
      >
        {expanded ? (
          <ChevronUp color={themeColors.chevron} size={16} />
        ) : (
          <ChevronDown color={themeColors.chevron} size={16} />
        )}
      </div>
    </div>
  )
}

export default Disclaimer
